import { createContext, PropsWithChildren, useContext } from 'react';
import { IParameterService, IProductService } from 'shared/services';
import { AppConfig } from 'shared/types';

export interface ServiceContext {
    appConfig: AppConfig;
    productService: IProductService;
    parameterService: IParameterService;
}
type ServiceProviderProps = {
    context: ServiceContext;
};

const serviceContext = createContext<ServiceContext>({} as ServiceContext);

export function ProvideService({ children, context }: PropsWithChildren<ServiceProviderProps>) {
    return <serviceContext.Provider value={context}>{children}</serviceContext.Provider>;
}

export function useService() {
    return useContext(serviceContext);
}
